"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_UPLOAD = exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = void 0;
const client_1 = require("@apollo/client");
exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO = (0, client_1.gql) `
  fragment AllAttachedGarageCrawlspaceInfo on AttachedGarageCrawlspaceInfo {
    sqft
    netAreaOfFloodOpenings
    numFloodOpenings
    engineeredFloodOpenings
    oneFloodOpeningTwoSides
    numNonEngineeredOpenings
    numEngineeredOpenings
    netAreaNonEngineeredOpenings
    ratedAreaOfEngineeredOpenings
  }
`;
exports.DOCUMENT_UPLOAD_DATA_FRAGMENT = (0, client_1.gql) `
  fragment DocumentUploadDataFragment on DocumentUpload {
    id
    originalFilename
    name
    formData
    formStructure @skip(if: $isPublic)
    createdAt
    isDeletable @skip(if: $isPublic)
    hasAssociatedAIActionRun
    externalDocumentURL
    accountDocumentType {
      id
      name
      color
      allowedMimeTypes
      attachments {
        type
        customMapIds
      }
      order
      isSensitive
      documentType {
        id
        name
      }
    }
    issuedAt
    hiddenFromPublic
    mimeType

    submission @skip(if: $isPublic) {
      id
      formData
      tags {
        text
        display: tagDisplay
        uiSchemaPath
      }
      submissionTypeVersion {
        id
        submissionType {
          id
          name
          description
        }
      }
    }
  }
`;
exports.DOCUMENT_UPLOAD = (0, client_1.gql) `
  query getDocumentUpload($id: ID!, $isPublic: Boolean!) {
    documentUpload(id: $id) {
      ...DocumentUploadDataFragment

      objectType
      objectId
      property {
        id
        streetAddress
        city
        state
        zipcode
        fullAddress
        latitude
        longitude
        hiddenFromPublic
        parcel {
          parcelId
          block
          lot
        }
      }

      customMapGeometry {
        id
        customMapId
        customMap {
          id
          hiddenFromPublic
        }
      }

      elevationCertificate {
        id
        buildingOwnerName
        errorDetectionEligibility {
          status
          heading
          note
        }
        type
        propertyDescription
        buildingUse
        latitude
        longitude
        horizontalDatum
        buildingDiagramNumber
        firmIndexDate
        firmPanelEffectiveDate
        floodZone
        baseFloodElevation
        baseFloodElevationDatum
        baseFloodElevationDatumOther
        baseFloodElevationSource
        fiveHundredYearFloodElevation {
          value
          units
        }
        isBuildingLocatedInCbrsOrOpa
        buildingLocatedInCbrsOrOpaDesignationDate
        buildingLocatedInCbrsOrOpa
        buildingLocatedSeawardOfLimwa
        benchmarkUtilized
        elevationDatum
        elevationDatumOther
        verticalDatum
        elevationDatumComments
        buildingElevationSource
        buildingElevationInfo {
          topOfBottomFloor {
            value
            units
          }
          topOfNextHigherFloor {
            value
            units
          }
          bottomOfLowestHorizontalStructuralMember {
            value
            units
          }
          attachedGarage {
            value
            units
          }
          lowestElevationOfMachineryOrEquipment {
            value
            units
          }
          lowestAdjacentGrade {
            value
            units
            type
          }
          highestAdjacentGrade {
            value
            units
            type
          }
          lowestAdjacentGradeAtLowestElevationOfDeckOrStairs {
            value
            units
          }
        }
        issuedAt
        comments
        coordinatesProvidedBySurveyor
        conversionFactorUsed
        streetAddress
        nfipCommunityName
        nfipCommunityNumber
        nfipCountyName
        nfipState
        state
        city
        zipcode
        certifierName
        certifierLicenseNumber
        certifierInfo {
          name
          licenseNumber
          email
          telephone
          sealPresent
          signaturePresent
        }
        propertyOwnerInfo {
          name
          signaturePresent
          date
        }
        firmMapNumber
        firmSuffix
        extractedData
        finishedConstruction
        formYear
        attachedGarageInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        crawlspaceInfo {
          ...AllAttachedGarageCrawlspaceInfo
        }
        buildingMeasurementInfo {
          measurementsBasedOn
          topOfBottomFloorElevatedPerOrdinance
          offsets {
            topOfBottomFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfBottomFloorAboveOrBelowLag {
              value
              units
              aboveOrBelow
            }
            nextHigherFloorAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            attachedGarageTopOfSlabAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
            topOfMachineryPlatformAboveOrBelowHag {
              value
              units
              aboveOrBelow
            }
          }
        }
        communityInfo {
          sectionCTakenFromOtherAuthorizedSource
          sectionECompletedByLocalOfficial
          sectionHCompletedByLocalOfficial
          sectionGCommentsProvidedByLocalOfficial
          communityInfoProvidedForFloodplainManagementPurposes
          permitNumber
          permitDateIssued
          certificateOfComplianceOrOccupancyDateIssued
          permitIssuedForNewConstructionOrSI
          elevations {
            asBuiltLowestFloor {
              value
              units
              datum
            }
            bottomOfAsBuiltLowestHorizontalStructuralMember {
              value
              units
              datum
            }
            bfeOrDepthOfFloodingAtBuildingSite {
              value
              units
              datum
            }
            communityMinimumRequirementOfLowestFloorOrLowestHorizontalStructuralMember {
              value
              units
              datum
            }
          }
          varianceIssued
          localOfficialInfo {
            name
            telephone
            email
            dateSigned
            comments
            signaturePresent
          }
        }
        everyPageHasHeaderAddress
        pageHeaderAddressesAreConsistent
        numberOfPhotosProvided
        everyPhotoIsInColor
        validationErrors {
          data {
            errorCode
            id
            issue
            type
            value
            valueAttr
            field
            note
            ignored
            ignoredReason @skip(if: $isPublic)
          }
          count
        }
        firms {
          id
          name
          floodway
          jurisdictions
          useForRegulation
          datum
          stringStaticBFE
          stringDepth
          isApproximateBfe
          mscLink
          coastalA
          panels {
            panelNumber
          }
          zones {
            floodzone
            floodway
            coastalA
            stringStaticBFE
            stringDepth
            datum
          }
        }
      }

      certificateUpload {
        id
        cancelationReason @skip(if: $isPublic)
        uploadSource @skip(if: $isPublic)
        status
        lowConfidence @skip(if: $isPublic)
        extractedAddress @skip(if: $isPublic) {
          streetAddress
          city
          state
          zipcode
        }
        geocodeData @skip(if: $isPublic) {
          errors {
            field
            message
          }
        }
      }
    }
  }

  ${exports.DOCUMENT_UPLOAD_DATA_FRAGMENT}
  ${exports.ALL_ATTACHED_GARAGE_CRAWLSPACE_INFO}
`;
(0, client_1.gql) `
  mutation UploadDocuments($data: CreateDocumentUploadsInput!) {
    createDocumentUploads(data: $data)
  }
`;
(0, client_1.gql) `
  mutation geocodeDocumentUpload(
    $documentUploadId: ID!
    $geocodeData: GeocodeDataInput!
  ) {
    geocodeDocumentUpload(
      documentUploadId: $documentUploadId
      geocodeData: $geocodeData
    )
  }
`;
//# sourceMappingURL=data:application/json;base64,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